import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState, selectBanks, selectBanksError, selectBanksLoading, selectCountries, selectCountriesError, selectCountriesLoading, selectRecipientBanks, selectRecipientBanksError, selectRecipientBanksLoading, selectRecipientCategories, selectRecipientCategoriesError, selectRecipientCategoriesLoading, selectValidatedAccount, selectValidatingAccount, selectValidatingAccountError, selectXcelAccount, selectXcelAccountError, selectXcelAccountLoading } from 'app/reducers';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import * as bulkPayActions from '../_state/bulk-pay.actions'
import * as productsActions from '../../products/_state/products.actions';
import { Bank } from 'app/modules/products/_state/products.interfaces';
import { takeUntil } from 'rxjs/operators';
import { RecipientBulkDto, RecipientDto } from '../_state/bulk-pay.dtos';
import { Country, Recipient } from '../_state/bulk-pay.interfaces';
import { ExcelService } from 'app/misc/excel.service';
import { BulkPayService } from '../bulk-pay.service';

@Component({
  selector: 'app-create-receipts',
  templateUrl: './create-receipts.component.html',
  styleUrls: ['./create-receipts.component.css']
})
export class CreateReceiptsComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<void>();

  constructor(
    protected store: Store<AppState>,
    protected actions$: Actions,
    protected toastr: ToastrService,
    protected router: Router,
    public miscService: MiscService,
    protected excelService : ExcelService,
    protected bulkpayService: BulkPayService
  ) { }

  recipientForm: FormGroup;
  banks: Bank[];
  selectedBank: Bank;
  selectedCardNumber: string;
  isCreating: boolean;
  countries: Country[];
  recipientCountryCode: string
  fileName: string;
  isManualInput:boolean
  newRecipientsArray: RecipientBulkDto[] = []
  protected unsubscribe$ = new Subject<void>();
  recipientsCategories$ = this.store.pipe(select(selectRecipientCategories))
  recipientsCategoriesLoading$ = this.store.pipe(select(selectRecipientCategoriesLoading))
  recipientsCategoriesError$ = this.store.pipe(select(selectRecipientCategoriesError))

  banks$ = this.store.pipe(select(selectRecipientBanks))
  banksLoading$ = this.store.pipe(select(selectRecipientBanksLoading))
  banksError$ = this.store.pipe(select(selectRecipientBanksError))

  validatedAccount$ = this.store.pipe(select(selectValidatedAccount))
  validatingAccount$ = this.store.pipe(select(selectValidatingAccount))
  validatingAccountError$ = this.store.pipe(select(selectValidatingAccountError))

  xcelAccount$ = this.store.pipe(select(selectXcelAccount))
  validatingXcelAccount$ = this.store.pipe(select(selectXcelAccountLoading))
  validatingXcelAccountError$ = this.store.pipe(select(selectXcelAccountError))

  countries$ = this.store.pipe(select(selectCountries))
  countriesLoading$ = this.store.pipe(select(selectCountriesLoading))
  countriesError$ = this.store.pipe(select(selectCountriesError))

  countryList: any[] = [];
  user: any;
  cachedBanks

  ngOnInit(): void {
    this.user = this.miscService.getMerchantDetails();
    this.recipientForm = new FormGroup({
      recipientCountry: new FormControl('', Validators.required),
      receiptAccountType: new FormControl('', Validators.required),
      price: new FormControl(''),
      bank: new FormControl(''),
      accountNumber: new FormControl(''),
      xcelAccount: new FormControl(''),
      recipientName: new FormControl('', Validators.required),
      description: new FormControl(''),
      // receiptCategory: new FormControl('', Validators.required)
    })
    this.countries$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: Country[]) => this.countries = res)
    this.banks$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: Bank[]) => {
      this.banks = res;
      this.cachedBanks = res;
    })
    this.fetchRecipientsCategories();
    this.fetchCountries();
    this.onValidateBankAccountSuccessful();
    this.onValidateXcelAccountSuccessful();
    this.onCreateRecipientFailed();
    this.onCreateRecipientSuccessful();
    this.onFetchCountriesSuccessful();
    this.onFetchCountriesFailed();
  }


    onFetchCountriesSuccessful = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.fetchCountriesSuccess),
        takeUntil(this.unsubscribe$)
      ).subscribe(response => {
        for (let index = 0; index < response.countries.length; index++) {
          const element = response.countries[index];
          if (element.callingCode == this.user.country_code) {
            this.countryList.push(element);
          }
        }
      })
    }
    onFetchCountriesFailed = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.fetchCountriesFailed),
        takeUntil(this.unsubscribe$)
      ).subscribe(response => {
          
      })
    }

    // API CALLS
    fetchCountries = () =>  this.store.dispatch(bulkPayActions.fetchCountries())

    fetchRecipientsCategories = () => {
    this.store.dispatch(bulkPayActions.fetchRecipientCategories({ page: 1, limit: 10 }));

    }
    

    fetchRecipientBanks = (countryCode) =>  this.store.dispatch(bulkPayActions.fetchRecipientBanks({countryCode}))

    validateBankAccount = () =>  { 
      if(!this.recipientForm.get('bank').value || !this.recipientForm.get('accountNumber').value){
        return;
      }else {
          this.store.dispatch(productsActions.validateAccount({
          bankCode: this.selectedBank.bank_code, 
          accountNumber: this.recipientForm.get('accountNumber').value,
          countryCode: this.user.currency.iso_code_2
        }))
      }
  }

  validateXcelAccount = () => {
    this.store.dispatch(bulkPayActions.validateXcelAccount({
      walletNumber: this.recipientForm.get('xcelAccount').value,
      schemeCode: this.miscService.formatCountryCode(this.recipientCountryCode) + '004'
    }))
  }
@Input() categoryId
  createRecipient = () => {
    this.isCreating = true;
    let requestBody = new RecipientDto();
    requestBody = {
      merchant_id: this.miscService.getMerchantDetails().merchant_id,
      name: this.recipientForm.get('recipientName').value,
      card_num: this.selectedCardNumber || '',
      wallet: this.recipientForm.get('xcelAccount').value || '',
      country_code: this.recipientCountryCode,
      scheme_code: this.miscService.formatCountryCode(this.recipientCountryCode) + '004',
      payment_type: this.recipientForm.get('receiptAccountType').value,
      src_name: this.recipientForm.get('recipientName').value || '',
      category_id:  this.categoryId,
      amount: this.recipientForm.get('price').value.toString() || '',
      description: this.recipientForm.get('description').value || '',
      bank:{
          bank_name: this.selectedBank?.bank_name || this.recipientForm.get('bank')?.value || '',
          bank_code: this.selectedBank?.bank_code || '',
          country_code: this.selectedBank?.country_code || '',
          account_no: this.recipientForm.get('accountNumber')?.value || '',
          sort_code: "",
          route_no:""
      }
    };
    this.store.dispatch(bulkPayActions.createRecipient({recipientDto: requestBody}))
  }

  // createBulkRecipient = (recipient: RecipientBulkDto) => {
  //   this.isCreating = true;
  //   let requestBody = new RecipientDto();
  //   requestBody = { 
  //     merchant_id: recipient.merchant_id,
  //     name: recipient.name,
  //     card_num: recipient.card_num,
  //     wallet: recipient.wallet,
  //     src_name: '',
  //     country_code: recipient.country_code,
  //     scheme_code: recipient.scheme_code,
  //     payment_type: recipient.payment_type,
  //     category_id: recipient.category_id,
  //     amount: recipient.amount,
  //     bank:{
  //         bank_name: recipient.bank.bank_name,
  //         bank_code: recipient.bank.bank_code,
  //         country_code: recipient.country_code,
  //         account_no: recipient.bank.account_no,
  //         sort_code: "",
  //         route_no:""
  //     }
  //   };
  //   this.bulkpayService.createRecipient(requestBody).subscribe(
  //     res => {
  //       this.isCreating = false;
  //       this.toastr.success('Recipient created', 'Success')
  //     },
  //     err => {
  //       this.toastr.error(`Failed to create ${recipient.name} as a recipient`, 'Error')
  //       this.isCreating = false;
  //     }
  //   )
  // }



  //Callbacks
  onValidateBankAccountSuccessful = () => {
    this.actions$.pipe(
      ofType(productsActions.validateAccountSuccess),
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
      this.recipientForm.get('recipientName').setValue(response['accountDetails']['name'])
      // this.recipientCountryCode = this.countries.find(country => country.alpha3Code === response['accountDetails']['country_code']).callingCode
    })
  }

  onValidateXcelAccountSuccessful = () => {
    this.actions$.pipe(
      ofType(bulkPayActions.validateXcelAccountSuccess),
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
      this.recipientForm.get('recipientName').setValue(`${response['xcelAccount']['first_name']} ${response['xcelAccount']['last_name']}`)
      this.selectedCardNumber = response['xcelAccount']['card_num']?  response['xcelAccount']['card_num'] : response['xcelAccount']['account_id'] 
      // this.recipientCountryCode = response['xcelAccount']['scheme_code']?.slice(0,3)
    })
  }

  onCreateRecipientSuccessful = () => {
    this.actions$.pipe(
      ofType(bulkPayActions.createRecipientSuccess),
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
        this.isCreating = false;
        this.selectedBank = null;
        this.selectedCardNumber = null;
        this.recipientForm.reset()
        this.closeModalEvent.emit();
        this.toastr.success('Recipient created', 'Success')
    })
  }
  onCreateRecipientFailed = () => {
    this.actions$.pipe(
      ofType(bulkPayActions.createRecipientFailed),
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
        this.isCreating = false;
    })
  }
  //Template Interactions
  selectBank = (e):any => this.selectedBank = this.banks.find(bank => bank.bank_code == e.target.value);

  resetFields = (e) => {
    if(e.target.value == 'Wallet'){
      this.recipientForm.get('bank').reset();
      this.recipientForm.get('accountNumber').reset();
      this.recipientForm.get('recipientName').reset();
    } else if(e.target.value == 'Account') {
      this.recipientForm.get('xcelAccount').reset();
      this.recipientForm.get('recipientName').reset();
      this.banks = this.cachedBanks
    } else if (e.target.value == 'momo'){
      this.recipientForm.get('xcelAccount').reset();
      this.recipientForm.get('recipientName').reset();
      this.banks = this.cachedBanks.filter(bank => bank.type == 'momo')
    }
  }

  // uploadExcel(event) {
  //   this.newRecipientsArray = [];
  //   let files = event.target.files
  //   if (files.length === 0)
  //     return;
 
  //   this.fileName = files[0].name
  //   var mimeType = files[0].type;
  //   if (mimeType.match(/application\/vnd.ms-excel*/) == null && mimeType.match(/application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet*/) == null) {
  //     return;
  //   }

  //   if(files[0].size > 3000000){
  //     return;
  //   }
  //   var reader = new FileReader();
  //   reader.onload = (_event) => { 
  //     let arrOfArr  = this.excelService.convertExcelFileToJsonArray(reader.result); 
  //     this.newRecipientsArray =  [].concat.apply([], arrOfArr).map(this.ConvertToDto.bind(this))
  //     console.log(this.newRecipientsArray)
  //     this.newRecipientsArray.map(recipient => {
  //       if(recipient.wallet){
  //         this.miscService.validateXcelAccount(recipient.wallet, this.miscService.formatCountryCode(recipient.country_code) + '004').subscribe(
  //           res => {
  //             recipient.name = `${res['data']['first_name']} ${res['data']['last_name']}`
  //             recipient.card_num = `${res['data']['card_num']}`
  //             recipient.scheme_code = `${res['data']['scheme_code']}`
  //             this.createBulkRecipient(recipient)
  //           },
  //           err => {
  //             this.toastr.error(`Account validation failed for xcel account ${recipient.wallet}`)
  //           }
  //         )
  //         }
  //         else if(recipient.bank?.account_no){
  //           this.miscService.validateAccount( recipient.bank.bank_code, recipient.bank.account_no, this.user.currency.iso_code_2).subscribe(
  //             res => {
  //               recipient.name = `${res['data']['name']}`
  //               recipient.scheme_code = this.miscService.formatCountryCode(recipient.country_code) + '004'
  //               this.createBulkRecipient(recipient)
  //           },
  //           err => {
  //             this.toastr.error(`Account validation failed for bank account ${recipient.bank.account_no}`)
  //           }
  //         )
  //       }
  //     })
  //   }
  //   reader.readAsBinaryString(files[0]);
  // }

  ConvertToDto(element) : RecipientBulkDto{
    const newRecipient : RecipientBulkDto = new RecipientBulkDto();
    if(element.xcelAccount){
      newRecipient.merchant_id = this.miscService.getMerchantDetails().merchant_id;
      newRecipient.name = '';
      newRecipient.card_num = '';
      newRecipient.wallet = element.xcelAccount.toString() || '';
      newRecipient.country_code = element.countryCode.toString() || '';
      newRecipient.scheme_code = ''
      newRecipient.payment_type =  'Wallet'
      newRecipient.category_id = element.categoryId;
      newRecipient.amount = element.amount.toString() || ''
      newRecipient.currency_code = element.currency_code || ''
      newRecipient.bank = {
        bank_name :  '',
        bank_code : '',
        country_code :  '',
        account_no :  '',
        route_no :  '',
        sort_code :  ''
      }
      return newRecipient
    }else {
      newRecipient.merchant_id = this.miscService.getMerchantDetails().merchant_id;
      newRecipient.name = '';
      newRecipient.card_num = '';
      newRecipient.wallet = '';
      newRecipient.country_code = element.countryCode.toString() || '';
      newRecipient.scheme_code = ''
      newRecipient.payment_type =  'Account';
      newRecipient.category_id = element.categoryId;
      newRecipient.amount = element.amount.toString() || ''
      newRecipient.currency_code = element.currencyCode || ''
      newRecipient.bank = {
        bank_name : element.bankName || '',
        bank_code : element.bankCode || '',
        country_code : element.countryCode.toString() || '',
        account_no : element.bankAccountNo ||'',
        route_no :  '',
        sort_code : ''
      }
      return newRecipient
    }
  }


    // UNSUBCRIBE FROM OBSERVABLES
    ngOnDestroy(): void {
      this.recipientForm.reset()
      this.unsubscribe$.next()
      this.unsubscribe$.complete()
    }

}
